import { httpApi } from '@app/api/http.api'

import { RodoDocumentsStatus } from '@/types/general-types'

export type RodoDocumentsResponse = {
  id: string
  name: string
  description: string
  documentationFile: {
    content: string
    name: string
    type: string
  }
  status: RodoDocumentsStatus
  createdAt: string
}

export type CreateDocumentsPayload = {
  name: string
  description: string
  documentationFile: {
    content: string
    name: string
    type: string
  }
}

export type ActiveDocument = {
  id: string
  name: string
  documentationFile: {
    content: string
    name: string
    type: string
  }
} | null

const RODO_POLICIES = 'rodo-policies'

export const getRodoPoliciesDocuments = (): Promise<RodoDocumentsResponse[]> =>
  httpApi.get<RodoDocumentsResponse[]>(`${RODO_POLICIES}/all`).then(({ data }) => data)

export const getActiveRodoPolicy = (): Promise<ActiveDocument> =>
  httpApi.get<ActiveDocument>(`${RODO_POLICIES}/active`).then(({ data }) => data)

export const createRodoPolicyDocument = (payload: CreateDocumentsPayload): Promise<string> =>
  httpApi.post<string>(`${RODO_POLICIES}/create`, payload).then(({ data }) => data)
